import React from 'react'
import S3Uploader from './s3-uploader'
import FileListItem from './list-item'
import createReactClass from 'create-react-class'

export default createReactClass({
  displayName: 'Files',

  handleUploadProgress () {
    console.log('handleUploadProgress', arguments)
    return true
  },

  handleUploadError () {
    console.log('handleUploadError', arguments)
  },

  handleUploadFinish (s3result, file) {
    this.props.postFile(s3result, file)
  },

  render () {
    const fileComponents = this.props.data.map(file => {
      return <FileListItem key={file.id} file={file} />
    })
    return (
      <div>
        <div>
          <S3Uploader
            accept="image/*"
            multiple
            onProgress={this.handleUploadProgress}
            onError={this.handleUploadError}
            onFinish={this.handleUploadFinish}
            signingUrl="/api/s3/sign"
          />
        </div>
        <table className="table">
          <tbody>
            {fileComponents}
          </tbody>
        </table>
      </div>
    )
  }
})
